export const actionTypes: any = {
  GET_CREDIT_ELIGIBILITY_REPORT_START: 'GET_CREDIT_ELIGIBILITY_REPORT_START',
  GET_CREDIT_ELIGIBILITY_REPORT_SUCCESS: 'GET_CREDIT_ELIGIBILITY_REPORT_SUCCESS',
  GET_CREDIT_ELIGIBILITY_REPORT_FINISH: 'GET_CREDIT_ELIGIBILITY_REPORT_FINISH',
}
